import {Constructor, EventContext, EventHandler} from './types';

export class Subscription<T> {
	constructor(private handler: EventHandler<T>, private eventType: Constructor<T>) {
	}

	public next(args: T, context: EventContext): void {
		try {
			this.handler(args, context);
		} catch (e) {
			console.error(`Error while handling ${this.eventType}.\n`, e);
		}
	}
}
